<template>
<div>
  <p v-if="output && output.length > 0 && outputIsSimple" class="is-size-6 has-border-bottom">Findings ({{ output.length }})</p>
  <div v-if="outputIsSimple">
    <p v-for="(result, index) in output" :key="index">
      {{ result || '–' }}
    </p>
  </div>
  <p v-else>
    {{ output }}
  </p>
</div>
</template>
<script>
export default {

  props: {
    output: {
      type: Array|String,
      default: () => ([])
    }
  },

  computed: {
    outputIsSimple() {
      return this.output instanceof String
    }
  }

}
</script>
